import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getTransformedMeasureUnit, mmToInches, numToLetter} from "../../../helpers/sqftHelper";
import {iconHeight, iconLength, iconLink} from "../../../assetsSQFT";
import {miteredSectionInterface, miteredSegmentInterface} from "../../../interfaces/sqftInterfaces";
import {changeMiteredSection} from "../../../../../actions/sqftMiteredFunctions";
import sqftConfig from "../../canvas/store/sqftConfig";

const NavMiteredSegment = (props) => {
  const {miteredSegment, miteredSection, index} = props;

  let segmentLength = getTransformedMeasureUnit(miteredSegment.length.value);
  // let segmentThickness = miteredSegment.thickness.value;
  let segmentMaxLength = miteredSection.getMaxLength();

  const changeLength = (value) => {
    let newValue = sqftConfig.measureUnit === "Metric"
      ? mmToInches(+value)
      : +value;

    miteredSection.setSegmentLength(newValue, miteredSegment, miteredSection);
  }

  let SEGMENTS = miteredSection.getSegments();

  // const changeThickness = (value) => {
  //   let newValue = +value;
  //   miteredSection.setSegmentThickness(newValue, miteredSegment, miteredSection);
  // }

  const changeHeight = (value) => {
    let newValue = +value;
    miteredSection.setSegmentHeight(newValue, miteredSection);
  }

  return (
    <ul className="mitered-segment mitered-segment--double" data-id="${segment.id}">
      <li className="mitered-segment__content segment-height">
        <div className="segment-letter">{numToLetter(index + 1)}</div>
        <div className="segment-image">
          <img src={iconHeight} alt=""/>
        </div>
        <div className="segment-value">
          <input className="ui-input segment-value-input"
                 type="number"
                 min="0"
                 onChange={(e) => changeHeight(e.target.value)}
                 placeholder={miteredSegment.height}
                 value={miteredSegment.height} />
        </div>
        <div className="segment-description">
          <div>
            <img src={iconLink} alt=""/>
          </div>
          <div>
            height
          </div>
        </div>
      </li>
      <li className="mitered-segment__content segment-length">
        <div className="segment-image">
          <img src={iconLength} alt=""/>
        </div>
        <div className="segment-value">
          <input type="number"
                 max={segmentMaxLength}
                 min="0"
                 className="ui-input segment-value-input"
                 placeholder={segmentLength}
                 value={segmentLength}
                 disabled={SEGMENTS.length <= 1}
                 onChange={(e) => changeLength(e.target.value)} />
        </div>
        <div className="segment-description">
          length
        </div>
      </li>
      {/*<li className="mitered-segment__content segment-thickness">*/}
      {/*  <div className="segment-image">*/}
      {/*    <img src={iconThickness} alt=""/>*/}
      {/*  </div>*/}
      {/*  <div className="segment-value">*/}
      {/*    <input type="number"*/}
      {/*           min="0"*/}
      {/*           className="ui-input segment-value-input"*/}
      {/*           placeholder={segmentThickness}*/}
      {/*           value={segmentThickness}*/}
      {/*           onChange={(e) => changeThickness(e.target.value)} />*/}
      {/*  </div>*/}
      {/*  <div className="segment-description">*/}
      {/*    thickness*/}
      {/*  </div>*/}
      {/*</li>*/}
    </ul>
  );
};

NavMiteredSegment.propTypes = {
  navMiteredSegment: PropTypes.shape(miteredSegmentInterface),
  navMiteredSection: PropTypes.shape(miteredSectionInterface)
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
  changeMiteredSection
};


export default connect(mapStateToProps, mapDispatchToProps)(NavMiteredSegment);
